import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Typography from '@mui/material/Typography';
import { Stack } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import { ValidatorForm } from "react-material-ui-form-validator";
import axios from "../../../../axios-order";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { canWrite } from '../../../../utils/privilegeUtils';
// import "./TDSRecon.css";
import RefreshIcon from "@mui/icons-material/Refresh";
import BoxWrapper from "../../../../components/ui/boxWrapper";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { green } from '@mui/material/colors';
import Tooltip from "@mui/material/Tooltip";

import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import Divider from "@mui/material/Divider";
import Chip from '@mui/material/Chip';
import LoadingButton from '@mui/lab/LoadingButton';
import SelectField from "../../../../components/ui/basicSelectInput";
import excelIconImage from '../../../../asserts/images/excelicon.svg'



import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import DashboardBarChart from "../../Sales/TDSReconciliationSale/Dashboard/dashboardBarChart";

import CircularProgress from "@material-ui/core/CircularProgress";
import { IconButton } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="right" ref={ref} {...props} />;
});




export default function TDSPayableRecon() {
    let history = useHistory();

    const [newReconHistoryTable, setNewReconHistoryTable] = useState([]);

    const [errorMessageForBoxWrapper, setErrorMessageForBoxWrapper] = useState("");

    const [closeBoxWrapper, setCloseBoxWrapper] = useState(false);

    const [loaderForTable, setLoaderForTable] = useState(true);

    const [lastReconRunDatetime, setLastReconRunDatetime] = useState('')

    const [open, setOpen] = React.useState(false);

    const [itemToLock, setItemToLock] = useState(null);

    const [loadingButton, setLoadingButton] = useState(false)

    const [snackbarOpen, setSnackbarOpen] = useState(false);

    const [snackbarSeverity, setSnackbarSeverity] = useState("warning");

    const [responseMessage, setResponseMessage] = useState("");

    const [message, setMessage] = useState('');

    const handleBack = () => {
        history.push('/reconCards');
    };


    const handleProceed = (item) => {

        localStorage.setItem('tdsLiabilityStatusView', 'unpaid');
        localStorage.setItem("financial_year_26Q", `${item?.financial_year}`);
        localStorage.setItem("quarter_26Q", 'Q1');
        history.push({ pathname: `/TdsLiabilities` });

    };

    

    const handleSnackbarOpen = (message, severity) => {
        setSnackbarOpen(true);
        setSnackbarSeverity(severity);
        setResponseMessage(message);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    const getTdsReconDetails = () => {
        axios
            .get(
                `/form26/get_tds_payable_recon_details/${localStorage.getItem(
                    "business_entity_id"
                )}`
            )
            .then((res) => {
                setLoaderForTable(false);
                if (res.data) {
                    const records = res?.data?.records.map(record => ({
                        ...record,
                        excel_loading: false
                    }));
                    setNewReconHistoryTable(records);
                    setLastReconRunDatetime(res.data.recent_recon_date_time)
                }
            })
            .catch((error) => {
                setLoaderForTable(false);

                toast.error(error?.response?.data?.message, {
                    autoClose: 3000,
                    progress: 0,
                });
            });
    };

    useEffect(() => {
        getTdsReconDetails();
    }, []);


    const onSumbitLock = () => {
        setLoadingButton(true)

        const lockStatus = itemToLock ? ((!itemToLock.locked || itemToLock.locked === "N") ? "Y" : "N") : ''

        const lokedData = {
            "business_entity_id": localStorage.getItem("business_entity_id"),
            "financial_year": itemToLock ? itemToLock.financial_year : '',
            "locked": lockStatus
        }

        axios.post('/tds_payable/update_lockstatus', lokedData)
            .then((res) => {

                setLoadingButton(false)
                getTdsReconDetails()
                handleClose()

            })
            .catch((err) => {

            })

    }

    const handleClickOpen = (lock_item) => {
        if (lock_item.is_valid === "N") {
            handleSnackbarOpen("Recon has been invalidated due to data upload. Please rerun the recon.", 'warning');
        } else {
            const index = newReconHistoryTable.findIndex(item => item === lock_item)
            const locked_record_list = newReconHistoryTable.slice(0, index).filter(item => !item.locked || item.locked !== 'Y' && item.is_valid !== "N")
            const unlocked_record_list = newReconHistoryTable.slice(index + 1).filter(item => item.locked && item.locked !== 'N' && item.is_valid !== "N")
            const lockStatus = lock_item ? ((!lock_item.locked || lock_item.locked === "N") ? "Y" : "N") : ''

            if (lockStatus != "Y") {
                if (unlocked_record_list.length === 0) {
                    setItemToLock(lock_item);
                    setOpen(true);
                } else {
                    handleSnackbarOpen("Before unlocking this record, please ensure that future financial year records are unlocked.", 'warning');
                    handleClose()
                    setLoadingButton(false)
                }
            } else {
                if (locked_record_list.length == 0) {
                    setItemToLock(lock_item);
                    setOpen(true);

                } else {
                    handleSnackbarOpen("Before locking this record, please ensure that previous financial year records are locked.", 'warning');
                    handleClose()
                    setLoadingButton(false)
                }
            }
        }

    };


    const downloadBase64File = (contentType, base64Data, fileName) => {
        const linkSource = `data:${contentType};base64,${base64Data}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    const handleDownloadReport = (item) => {
        const contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const filename = `TDS Payable Reconciliation Report ${item.financial_year}.xlsx`;
        setNewReconHistoryTable(prevRecords =>
            prevRecords.map(record =>
                record.id === item.id ? { ...record, excel_loading: true } : record
            )
        );
        axios
            .post(`/get_payable_challan_recon_report`, {
                business_entity_id: localStorage.getItem("business_entity_id"),
                financial_year: item.financial_year,
            })
            .then((res) => {
                if (!res?.data?.status){
                   handleSnackbarOpen(res?.data?.message, 'warning') 
                }else{
                    downloadBase64File(contentType, res.data.file, filename);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
                setNewReconHistoryTable(prevRecords =>
                    prevRecords.map(record =>
                        record.id === item.id ? { ...record, excel_loading: false } : record
                    )
                );
            })
    }

    const renderLockConfirmationPopup = () => {
        return (
            <React.Fragment>
                <Dialog
                    open={open}
                    TransitionComponent={Transition}
                    onClose={handleClose}

                    aria-describedby="alert-dialog-slide-description"

                    PaperProps={{
                        style: {
                            display: 'flex',
                            flexDirection: 'row',
                            padding: '20px',
                            justifyContent: 'space-around'
                        },
                    }}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {itemToLock && itemToLock.status === "Pass" && (
                            itemToLock.locked === "N" || !itemToLock.locked ? (
                                <LockRoundedIcon
                                    className="action-icon-button showIcon"
                                    style={{ fontSize: '100px', marginBottom: '40px', pointerEvents: 'none' }}
                                    color="action"

                                />
                            ) : (
                                <LockOpenOutlinedIcon
                                    className="action-icon-button showIcon"
                                    style={{ fontSize: '100px', marginBottom: '40px', pointerEvents: 'none' }}
                                    color="action"
                                />
                            )
                        )}


                    </div>

                    <div>
                        <DialogTitle>{"Are you sure you want to " + (itemToLock && itemToLock.locked != "Y" ? "lock" : "unlock") + ` the record with financial year (${itemToLock && itemToLock.financial_year})?`}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                {`If you ${itemToLock && itemToLock.locked != "Y" ? "lock" : "unlock"} this record, then you ${itemToLock && itemToLock.locked != "Y" ? "won't be able to" : "can"} upload any TDS Payable related data.`}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button variant="outlined" onClick={handleClose}>Cancel</Button>
                            {/* <Button loading={loadingButton} variant="contained" onClick={() => onSumbitLock(itemToLock)}></Button> : */}
                            <LoadingButton
                                size="small"
                                onClick={() => onSumbitLock(itemToLock)}
                                loading={loadingButton}
                                variant="contained"
                                style={{ height: '36px', width: '90px' }}
                            >
                                <span>{itemToLock && itemToLock.locked != "Y" ? "Lock" : "Unlock"}</span>
                            </LoadingButton>
                        </DialogActions>
                    </div>

                </Dialog>

            </React.Fragment>
        );
    }


    const handleClose = () => {
        setOpen(false);
    };

    const showFailReason = (item) => {
        handleSnackbarOpen(item.fail_reason, 'warning');
    }

    const historyTableBody = () => {

        if (loaderForTable) {
            console.log("Loader");
            return (
                <tr>
                    <td
                        style={{ color: "black", textAlign: "right", fontWeight: "bold" }}
                        colspan={3}
                    >
                        Loading…Please wait
                    </td>
                </tr>
            );
        }

        else if (newReconHistoryTable && newReconHistoryTable.length > 0) {
            return newReconHistoryTable.map((item, index) => {

                return (
                    <tr key={item.financial_year}>
                        <td >{item.financial_year}</td>
                        <td>{item.book_tds_amount}</td>
                        <td>{item.tds_payble_as_per_cws}</td>
                        <td>{item.difference}</td>
                        <td>{item.status}</td>
                        <td style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                            {/* Visibility Icon */}
                            {item.status === "Pass" ? (
                                item.is_valid !== "N" ? (
                                    <VisibilityOutlinedIcon
                                        className="action-icon-button showIcon"
                                        onClick={() => handleProceed(item)}
                                        style={{ marginTop: 2 }}
                                        color="primary"
                                    />
                                ) : (
                                    <Tooltip title="Recon is Invalid">
                                        <VisibilityOutlinedIcon
                                            className="action-icon-button deleteIcon"
                                            color="disabled"
                                            style={{ marginTop: 2 }}
                                        />
                                    </Tooltip>
                                )
                            ) : item.status === "Fail" ? (
                                <VisibilityOutlinedIcon
                                    className="action-icon-button deleteIcon"
                                    onClick={() => showFailReason(item)}
                                    style={{ marginTop: 2 }}
                                />
                            ) : (
                                <VisibilityOutlinedIcon
                                    className="action-icon-button deleteIcon"
                                    color="disabled"
                                    style={{ marginTop: 2 }}
                                />
                            )}

                            {/* Lock Icon */}
                            {item.status === "Pass" ? (
                                item.locked === "Y" ? (
                                    <LockOpenOutlinedIcon
                                        className="action-icon-button showIcon"
                                        onClick={() => canWrite("PAYABLES") && handleClickOpen(item)}
                                        style={{ marginLeft: 12, cursor: canWrite("PAYABLES") ? 'pointer' : 'not-allowed' }}
                                        color={item.is_valid !== "N" && canWrite("PAYABLES") ? "primary" : "disabled"}
                                    />
                                ) : (
                                    <LockRoundedIcon
                                        className="action-icon-button showIcon"
                                        onClick={() => canWrite("PAYABLES") && handleClickOpen(item)}
                                        style={{ marginLeft: 12, cursor: canWrite("PAYABLES") ? 'pointer' : 'not-allowed' }}
                                        color={item.is_valid !== "N" && canWrite("PAYABLES") ? "primary" : "disabled"}
                                    />
                                )
                            ) : (
                                <LockRoundedIcon
                                    className="action-icon-button showIcon"
                                    color="disabled"
                                    style={{ marginLeft: 12 }}
                                />
                            )}

                            {/* Excel Icon / Progress */}
                            {item.status === "Pass" ? (
                                item.is_valid !== "N" ? (
                                    !item.excel_loading ? (
                                        <img
                                            onClick={() => handleDownloadReport(item)}
                                            style={{ marginLeft: 12, height: 23, width: 25, cursor: 'pointer' }}
                                            src={excelIconImage}
                                        />
                                    ) : (
                                        <CircularProgress
                                            size={20}
                                            style={{ color: "green", marginLeft: 5, marginTop: 2 }}
                                        />
                                    )
                                ) : (
                                    <Tooltip title="Recon is Invalid">
                                        <img
                                            style={{ marginLeft: 12, height: 23, width: 25 }}
                                            src={excelIconImage}
                                        />
                                    </Tooltip>
                                )
                            ) : (
                                <img
                                    style={{ marginLeft: 12, height: 23, width: 25, cursor: 'pointer' }}
                                    src={excelIconImage}
                                />
                            )}
                        </td>

                    </tr>
                );
            });
        }
        else {
            return (
                <tr>
                    <td
                        style={{ color: "black", textAlign: "right", fontWeight: "bold" }}
                        colspan={3}
                    >
                        No Data Found
                    </td>
                </tr>
            );
        }
    };

    const onClickRunTdsRecon = () => {

        const financial_year_list = newReconHistoryTable
            .filter(item => item.locked !== 'Y')
            .map(item => item.financial_year);
        const reconData = {
            business_entity_id: localStorage.getItem("business_entity_id"),
            org_gstin: localStorage.getItem('gst'),
            financial_year_list: financial_year_list
        }
        if (financial_year_list.length >= 1) {
            axios.post('/form26/run_tds_payable_challan_recon', reconData)
                .then((res) => {
                    getTdsReconDetails()
                })
                .catch((err) => {

                })
        } else {
            if (newReconHistoryTable.length >= 1) {
                handleSnackbarOpen("Please unlock records to run the Recon.", 'warning');

            } else {
                handleSnackbarOpen('There are no records available to run the Recon.', 'warning');
            }

        }
    }

    const refreshUploadHistoryTable = () => {
        getTdsReconDetails();
    };

    const FunForcloseBoxWapper = () => {
        setCloseBoxWrapper(false);
    };


    return (
        <>
            <div className="new-reconciliation-form" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', width: '100%' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    {canWrite("PAYABLES") && (
                    <button
                        className="button-outlined-primary"
                        onClick={onClickRunTdsRecon}
                    >
                        Run TDS Payable Recon
                    </button>
                    )}
                    <Tooltip title="Back" arrow>
                        <IconButton
                            onClick={handleBack}
                            sx={{
                                borderRadius: '50%',
                                padding: '6px',
                                color: '#263238',
                                fontSize: '20px',
                                backgroundColor: '#ffffff',
                                height: '36px',
                                width: '36px',
                                '&:hover': {
                                    backgroundColor: '#455a64',
                                    color: '#ffffff',
                                },
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                                transition: 'background-color 0.3s ease',
                            }}
                        >
                            <ArrowBackIcon sx={{ fontSize: '20px' }} />
                        </IconButton>
                    </Tooltip>
                </div>

                {lastReconRunDatetime && (
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto' }}>
                        <p style={{ marginRight: '10px' }}>
                            LAST RECON RUN DATE TIME:
                        </p>
                        <Chip label={lastReconRunDatetime} style={{ marginBottom: '3px' }} variant="outlined" color="primary" size="medium" />
                    </div>
                )}
            </div>


            {closeBoxWrapper && (
                <BoxWrapper
                    boxTitle="Error"
                    cutIcon={true}
                    children={errorMessageForBoxWrapper}
                    closeBoxWapper={FunForcloseBoxWapper}
                    colorForMessage="red"
                    ErrorIcon={<ErrorOutlineOutlinedIcon />}
                />
            )}

            {/* History table */}
            <BoxWrapper
                boxTitle="TDS PAYABLE RECON"
                // add button
                // exportToExcelEnable={newReconHistoryTable.length > 1 && true}
                // exportButtonLabel={'Export'}
                // exportToExcelFn={newReconFormModalOpen}
                enableIcon1={true}
                enableIcon1Value={
                    <Tooltip title="Refresh">
                        <RefreshIcon color="primary" sx={{ fontSize: '30px' }} />
                    </Tooltip>
                }
                handleIcon1ClickFunction={refreshUploadHistoryTable}
            >
                <div className="responsive-table" style={{ maxHeight: '50vh' }}>
                    <table className="custome-table">
                        <thead>
                            <tr>
                                <th>Fiscal Year</th>
                                <th>Books TDS</th>
                                <th>TDS Payable - CWS</th>
                                <th>Difference</th> 
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>{historyTableBody()}</tbody>
                    </table>
                </div>
            </BoxWrapper>



            {renderLockConfirmationPopup()}

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                open={snackbarOpen}
                autoHideDuration={5000} // Adjust as needed
                onClose={handleSnackbarClose}
                style={{ maxWidth: '25%' }}
            >
                <MuiAlert
                    elevation={6}
                    variant="filled"
                    onClose={handleSnackbarClose}
                    severity={snackbarSeverity} // Use the state variable to determine severity
                >
                    {responseMessage}
                    {message}
                </MuiAlert>
            </Snackbar>
        </>
    );
}
